import axiosInstance from ".";

export const getHome = () => {
  return axiosInstance.get("/admin/page-content?page_url=/home");
};

export const addHome = (data) => {
  return axiosInstance.post("/home", data);
};

export const updateHome = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/admin/page-content/${id}`, payload);
};

export const getAboutus = () => {
  return axiosInstance.get("/admin/page-content?page_url=/about-us");
};

export const addAboutus = (data) => {
  return axiosInstance.post("/home", data);
};

export const updateAboutus = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/admin/page-content/${id}`, payload);
};

export const getFeatures = () => {
  return axiosInstance.get("/admin/page-content?page_url=/features");
};

export const addFeatures = (data) => {
  return axiosInstance.post("/home", data);
};

export const updateFeatures = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/admin/page-content/${id}`, payload);
};

export const getHowItWorks = () => {
  return axiosInstance.get("/admin/page-content?page_url=/how-it-works");
};

export const addHowItWorks = (data) => {
  return axiosInstance.post("/home", data);
};

export const updateHowItWorks = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/admin/page-content/${id}`, payload);
};

export const getContactUs = () => {
  return axiosInstance.get("/admin/page-content?page_url=/contact-us");
};

export const addContactUs = (data) => {
  return axiosInstance.post("/home", data);
};

export const updateContactUs = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/admin/page-content/${id}`, payload);
};

export const getPricing = () => {
  return axiosInstance.get("/admin/page-content?page_url=/pricing");
};

export const addPricing = (data) => {
  return axiosInstance.post("/home", data);
};

export const updatePricing = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/admin/page-content/${id}`, payload);
};

export const getFaq = () => {
  return axiosInstance.get("/admin/page-content?page_url=/faq");
};

export const addFaq = (data) => {
  return axiosInstance.post("/home", data);
};

export const updateFaq = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/admin/page-content/${id}`, payload);
};

export const getBlog = () => {
  return axiosInstance.get("/admin/page-content?page_url=/blogs");
};

export const addBlog = (data) => {
  return axiosInstance.post("/home", data);
};

export const updateBlog = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/admin/page-content/${id}`, payload);
};


export const getFeaturesDemo = () => {
  return axiosInstance.get("/admin/page-content?page_url=/feature-demo");
};

export const addFeaturesDemo = (data) => {
  return axiosInstance.post("/home", data);
};

export const updateFeaturesDemo = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/admin/page-content/${id}`, payload);
};
// /courses


export const getCourses = () => {
  return axiosInstance.get("/admin/page-content?page_url=/courses");
};



export const updateCourses = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/admin/page-content/${id}`, payload);
};